<template lang="html">
  <nav class="nav tabs" role="tablist">
    <slot> </slot>
  </nav>
</template>

<script>
import jQuery from 'jquery/dist/jquery.js';

export default {
  props: {},
  mounted: function() {
    this.$nextTick(function() {
      jQuery('.tabs .button').addClass('nav-item nav-link');
      jQuery('.tabs .button').attr('data-toggle', 'tab');
    });
  },
};
</script>

<style lang="scss">
.tabs {
  &.nav-pills {
    .button.nav-link {
      margin-right: 10px;
    }
  }
  &.nav-tabs {
    .button.nav-link {
      background: transparent;
      color: gray(600) !important;
      border-radius: 4px 4px 0 0;
      &.active {
        color: gray(800) !important;
      }
      &:hover {
        background-color: transparent !important;
        color: gray(900) !important;
        &:after {
          content: none;
        }
      }
    }
  }

  @include media-breakpoint-down(sm) {
    &.nav-pills {
      .button.nav-link {
        width: 100%;
        margin: 0;
      }
    }
    &.nav-tabs {
      .button.nav-link {
        .button-inner {
          padding: 0 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/tabs.vue